
import axios from "axios";
import { OutputBaseProps } from "utils/types/API";
import { RoleItemProps } from "apis/role";
import { ApiFormAccessControllAllOutputProps } from ".";
import { AccessControllDataItemProps } from "layouts/admin/pages/permission/AccessControll/AccessControll";

interface R1 { type: "form"; formId: number };
interface R2 { type: "step"; formId: number; stepId: number }
interface R3 { type: "status"; formId: number; statusId: number }
type ApiFormAccessControllRoleInputProps = R1 | R2 | R3;

type ApiFormAccessControllRoleOutputProps = OutputBaseProps<RoleItemProps[]>

export const apiFormAccessControllRole = async (data: ApiFormAccessControllRoleInputProps) => {
    let url = "";
    switch (data.type) {
        case "form":
            url = `/api/form/${data.formId}/role/access-controll`;
            break;
        case "step":
            url = `/api/form/${data.formId}/step/${data.stepId}/role/access-controll`;
            break;
        case "status":
            url = `/api/form/${data.formId}/status/${data.statusId}/role/access-controll`;
            break;
        default:
            break;
    }
    const res = (await axios.get<ApiFormAccessControllRoleOutputProps>(url)).data;
    return res;
};


type ApiFormAccessControllRoleAllInputProps = { roleId: number }

type ApiFormAccessControllRoleAllOutputProps = ApiFormAccessControllAllOutputProps

export const apiFormAccessControllRoleAll = async (data: ApiFormAccessControllRoleAllInputProps) => {
    const res = (await axios.get<ApiFormAccessControllRoleAllOutputProps>(`/api/form/access-controll/role/${data.roleId}`)).data;
    return res;
};

interface ApiFormAccessControllRoleAllUpdateInputProps {
    roleId: number;
    data: AccessControllDataItemProps[]
}
export const apiFormAccessControllRoleAllUpdate = async (data: ApiFormAccessControllRoleAllUpdateInputProps) => {
    const res = (await axios.put<ApiFormAccessControllRoleAllOutputProps>(`/api/form/access-controll/role/update/${data.roleId}`, data.data)).data;
    return res;
};
